import { render, staticRenderFns } from "./Cooperation.vue?vue&type=template&id=58dc763f&scoped=true"
import script from "./Cooperation.vue?vue&type=script&lang=js"
export * from "./Cooperation.vue?vue&type=script&lang=js"
import style0 from "./Cooperation.vue?vue&type=style&index=0&id=58dc763f&prod&lang=less&scoped=true"
import style1 from "./Cooperation.vue?vue&type=style&index=1&id=58dc763f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dc763f",
  null
  
)

export default component.exports